<template>
  <div class="bioLook_details">
    <div class="top">
      <div class="title">
        <h2>{{info.title}}</h2>
      </div>
      <div class="time">
        <div>采购方 : {{info.purchaser}}</div>
        <div style="margin-left:30px;color:#999">{{info.create_date}} 发布</div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>产品要求</h3>
      </div>
      <div class="details">
        <div class="details_list">
          <div class="details_list1">产品名称</div>
          <div class="details_list2">{{info.product_title}}</div>
        </div>
        <div class="details_list">
          <div class="details_list1">使用场景</div>
          <div class="details_list2">{{info.use_sence}}</div>
        </div>
        <div class="details_list">
          <div class="details_list1">数量</div>
          <div class="details_list2">{{info.number}}</div>
        </div>
        <div class="details_list">
          <div class="details_list1">标准类型</div>
          <div class="details_list2">{{info.standard}}</div>
        </div>
        <div class="details_list">
          <div class="details_list1">图片示例</div>
          <div class="details_list2">
            <img :src="info.image" alt />
          </div>
        </div>
      </div>
    </div>

    <div class="content" style="margin-top:20px">
      <div class="title">
        <h3>更多要求</h3>
      </div>
      <div class="details">
        <div class="details_list">
          <div class="details_list1">资质要求</div>
          <div class="details_list2">{{info.other}}</div>
        </div>
      </div>
    </div>
    <div class="oper">
      <div class="btn">
        <el-button style="width:300px" @click="product_details1" type="primary">我要供货</el-button>
      </div>
      <div>
        <div class="qrcode">
          <div>
            <qrcode-vue
              style="padding:5px 5px"
              :value="'https://www.bioflin.com/#'+ $route.fullPath"
              :size="140"
              level="H"
            ></qrcode-vue>
          </div>
          <div>扫码分享</div>
        </div>
        <div class="d1 clearfix">
          <div class="idleHome_right_seach_ipt">{{'https://www.bioflin.com/#' + $route.fullPath}}</div>
          <el-button
            type="info"
            v-clipboard:copy="  'https://www.bioflin.com/#' + $route.fullPath"
            v-clipboard:success="onCopy"
            style="border-radius: 0;float: left;background:#4F9CDC;border-color:#4F9CDC"
          >复制链接</el-button>
        </div>
      </div>
    </div>
    <div style="height:20px"></div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      serve: this.$store.state.serve,
      id: this.$route.query.id,
      info: {}
    };
  },
  created() {
    this.axios
      .get(this.serve + "/supplyInfo", {
        params: {
          id: this.id
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.info = res.data.data.info;
        }
      });
  },
  methods: {
    product_details1() {
      this.$router.push("/bioLook_updata?id=" + this.id + '&a=' + Math.round(Math.random()*100));
    },
    success(msg) {
      this.$message.success({
        type: "success",
        message: msg,
        offset: 150
      });
    },
    onCopy() {
      this.success("链接已复制,快去分享吧！");
    }
  }
};
</script>

<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.bioLook_details {
  width: 1200px;
  margin: 0 auto;
  .top {
    background: #fff;
    margin-bottom: 20px;
    padding: 10px;
    .title {
      border-bottom: 1px solid #f2f2f2;
    }
    .time {
      display: flex;
      line-height: 50px;
    }
  }
  .content {
    background: #fff;
    padding: 10px;
    .title {
      //   line-height: px;
    }
    .details {
      padding-left: 20px;
      .details_list {
        display: flex;
        margin-bottom: 30px;
        .details_list1 {
          color: #222;
          line-height: 30px;

          width: 56px;
        }
        .details_list2 {
          margin-left: 150px;
          width: 800px;
          line-height: 30px;
          img {
            width: 126px;
            height: 176px;
          }
        }
      }
    }
  }
  .oper {
    width: 100%;
    background: #fff;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      margin: 0 auto;
    }
    .d1 {
      margin-top: 20px;
      .idleHome_right_seach_ipt {
        float: left;
        width: 420px;
        height: 40px;
        background: rgba(221, 221, 221, 1);
        border-radius: 2px 0px 0px 2px;
        line-height: 40px;
        padding-left: 10px;
      }
    }
  }
}
</style>
